<template>
  <div>
    <el-button type="primary" @click="getFormData">获取表单Json</el-button>
    <el-button type="primary" @click="setFormData">设置表单Json</el-button>
    <el-button type="primary" @click="clearDesigner">清空表单Json</el-button>
    <el-button type="primary" @click="refreshDesigner">刷新配置</el-button>
    <el-button type="primary" @click="previewForm">预览表单</el-button>
    <el-button type="primary" @click="importJson">导入Json</el-button>
    <el-button type="primary" @click="exportJson">导出Json</el-button>
    <el-button type="primary" @click="exportCode">导出代码</el-button>
    <el-button type="primary" @click="generateSFC">导出SFC</el-button>
    <el-button type="primary" @click="getWidgetRef">获取组件</el-button>
  </div>
</template>
<script>
import { computed, getCurrentInstance, reactive, ref, toRefs, onMounted } from 'vue';
export default {
  props: {
    designer: Function,
  },
  setup(props, context) {
    let designer = ref(null);

    onMounted(() => {
      designer.value = props.designer();
    });
    const methods = reactive({
      clearDesigner: () => {
        designer.value.clearDesigner();
      },
      exportCode: () => {
        designer.value.exportCode();
      },
      exportJson: () => {
        designer.value.exportJson();
      },
      generateSFC: () => {
        designer.value.generateSFC();
      },
      getFormData: () => {
        console.log(designer.value.getFormJson());
      },
      getWidgetRef: () => {
        console.log(designer.value.getWidgetRef('minput83984', true));
      },
      importJson: () => {
        designer.value.importJson();
      },
      previewForm: () => {
        designer.value.previewForm();
      },
      refreshDesigner: () => {
        designer.value.refreshDesigner();
      },
      setFormData: () => {
        let formData = {
          formConfig: {
            cssCode: '',
            customClass: [],
            dataSources: [],
            functions: '',
            jsonVersion: -3,
            labelAlign: 'label-left-align',
            labelPosition: 'left',
            labelWidth: 80,
            layoutType: 'PC',
            modelName: 'formData',
            onFormCreated: '',
            onFormDataChange: '',
            onFormMounted: '',
            refName: 'vForm',
            rulesName: 'rules',
            size: '',
          },
          widgetList: [
            {
              alias: '',
              category: 'container',
              cols: [
                {
                  category: 'container',
                  icon: 'grid-col',
                  id: 'grid-col-27881',
                  internal: true,
                  options: {
                    customClass: '',
                    hidden: false,
                    md: 12,
                    name: 'gridCol27881',
                    offset: 0,
                    pull: 0,
                    push: 0,
                    responsive: false,
                    sm: 12,
                    span: 12,
                    xs: 12,
                  },
                  type: 'grid-col',
                  widgetList: [
                    {
                      alias: '',
                      formItemFlag: true,
                      icon: 'text-field',
                      id: 'input101540',
                      key: 17754,
                      options: {
                        appendButton: false,
                        appendButtonDisabled: false,
                        buttonIcon: 'custom-search',
                        clearable: true,
                        columnWidth: '200px',
                        customClass: [],
                        defaultValue: '',
                        disabled: false,
                        hidden: false,
                        label: 'input',
                        labelAlign: '',
                        labelHidden: false,
                        labelIconClass: null,
                        labelIconPosition: 'rear',
                        labelTooltip: null,
                        labelWidth: null,
                        maxLength: null,
                        minLength: null,
                        name: 'input101540',
                        onAppendButtonClick: '',
                        onBlur: '',
                        onChange: '',
                        onCreated: '',
                        onFocus: '',
                        onInput: '',
                        onMounted: '',
                        onValidate: '',
                        placeholder: '',
                        prefixIcon: '',
                        readonly: false,
                        required: false,
                        requiredHint: '',
                        showPassword: false,
                        showWordLimit: false,
                        size: '',
                        suffixIcon: '',
                        type: 'text',
                        validation: '',
                        validationHint: '',
                      },
                      type: 'input',
                    },
                  ],
                },
                {
                  category: 'container',
                  icon: 'grid-col',
                  id: 'grid-col-77775',
                  internal: true,
                  options: {
                    customClass: '',
                    hidden: false,
                    md: 12,
                    name: 'gridCol77775',
                    offset: 0,
                    pull: 0,
                    push: 0,
                    responsive: false,
                    sm: 12,
                    span: 12,
                    xs: 12,
                  },
                  type: 'grid-col',
                  widgetList: [],
                },
              ],
              icon: 'grid',
              id: 'grid38170',
              key: 79483,
              options: {
                colHeight: null,
                customClass: [],
                gutter: 12,
                hidden: false,
                name: 'grid38170',
              },
              type: 'grid',
            },
            {
              alias: '',
              formItemFlag: true,
              icon: 'text-field',
              id: 'input95212',
              key: 45083,
              options: {
                appendButton: false,
                appendButtonDisabled: false,
                buttonIcon: 'custom-search',
                clearable: true,
                columnWidth: '200px',
                customClass: [],
                defaultValue: '',
                disabled: false,
                hidden: false,
                label: 'input',
                labelAlign: '',
                labelHidden: false,
                labelIconClass: null,
                labelIconPosition: 'rear',
                labelTooltip: null,
                labelWidth: null,
                maxLength: null,
                minLength: null,
                name: 'input95212',
                onAppendButtonClick: '',
                onBlur: '',
                onChange: '',
                onCreated: '',
                onFocus: '',
                onInput: '',
                onMounted: '',
                onValidate: '',
                placeholder: '',
                prefixIcon: '',
                readonly: false,
                required: false,
                requiredHint: '',
                showPassword: false,
                showWordLimit: false,
                size: '',
                suffixIcon: '',
                type: 'text',
                validation: '',
                validationHint: '',
              },
              type: 'input',
            },
          ],
        };
        designer.value.setFormJson(formData);
      },
    });

    return {
      ...methods,
    };
  },
};
</script>
